<app-menu-component/>
<router-outlet></router-outlet>
<app-footer-component/>
<app-cookie-consent/>
<app-toaster-component/>